import { render, staticRenderFns } from "./connector-detail.vue?vue&type=template&id=0cd807bf&scoped=true"
import script from "./connector-detail.vue?vue&type=script&lang=js"
export * from "./connector-detail.vue?vue&type=script&lang=js"
import style0 from "./connector-detail.vue?vue&type=style&index=0&id=0cd807bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd807bf",
  null
  
)

export default component.exports